// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"553":"9fc83b0a","977":"934b44c1"}[chunkId] + ".chunk.js";
};